import React, { useEffect, useState } from 'react';
import { useCancelSubscriptionMutation } from '@/features/subscription/apiSlice';
import { useDatasourceId } from '@/hooks';
import { TrevorIcon } from '@trevor/ui-components';
import { successMessage } from '@/features/subscription/components/utils';
import AjaxSpinner from '@/components/AjaxSpinner';
import { useNavigate } from 'react-router-dom';
import {
  BackButton,
  CommentInput,
  ConfirmInput,
  ContentWrapper,
  ViewTitle,
  Label,
  CancelSubscriptionButton,
  ButtonAjaxSpinner,
  PageLoading,
} from './styled-components';

const CancelSubscription: React.FC = () => {
  const datasourceId = useDatasourceId();
  const navigate = useNavigate();

  const [cancelSubscription, result] = useCancelSubscriptionMutation();

  const [feedback, setFeedback] = useState('');
  const [confirmText, setConfirmText] = useState('');

  const isButtonDisabled =
    feedback.split(' ').join('').length < 2 || confirmText !== 'CANCEL';

  useEffect(() => {
    if (result?.isSuccess) {
      successMessage('Subscription canceled');
      setTimeout(() => {
        window.open(`/datasources/${datasourceId}`, '_self');
      }, 1500);
    }
  }, [result?.isSuccess]);

  if (result?.isSuccess) {
    return (
      <PageLoading>
        <AjaxSpinner />
      </PageLoading>
    );
  }

  return (
    <ContentWrapper>
      <BackButton onClick={() => navigate('..')}>
        <TrevorIcon name="chevron-left" /> Back
      </BackButton>
      <ViewTitle>Cancel plan</ViewTitle>
      <Label>Please tell us why you are cancelling your plan.</Label>
      <CommentInput
        maxLength={500}
        value={feedback}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          setFeedback(e.target.value);
        }}
      />
      <Label>Type the word CANCEL to confirm cancellation.</Label>
      <ConfirmInput
        value={confirmText}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setConfirmText(e.target.value);
        }}
      />
      <CancelSubscriptionButton
        onClick={() => cancelSubscription({ datasourceId, feedback })}
        isLoading={result?.isLoading}
        disabled={isButtonDisabled}
      >
        {result?.isLoading ? (
          <ButtonAjaxSpinner />
        ) : (
          <TrevorIcon name="cancel-plan" />
        )}
        {result?.isLoading ? 'Canceling' : 'Cancel plan'}
      </CancelSubscriptionButton>
      Please complete both fields above
    </ContentWrapper>
  );
};

export default CancelSubscription;
